<template>
  <div
    class="modal fade"
    id="modalMessage"
    @drop="drop($event)"
    @dragenter="dragenter($event)"
    @dragover="dragover($event)"
  >
    <div class="modal-dialog" role="document">
      <modal-loading :show="loading"></modal-loading>
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{ $t("mall.咨询详情") }}</h4>
        </div>
        <div class="modal-body">
          <a
            v-if="Number(num) > Number(totalCount)"
            class="new-msg"
            href="javascript:;"
            @click="getMessage()"
          >
            {{ $t("mall.有") }}{{ Number(num) - Number(totalCount)
            }}{{ $t("mall.条新数据，点此读取") }}
          </a>
          <div class="msg-list">
            <ul>
              <li
                v-for="item in items"
                :key="item.id"
                :class="{ my: item.type == 2 }"
              >
                <div class="date">{{ item.timeCreated }}</div>
                <div class="message-wrap">
                  <div class="user">
                    {{ item.type == 2 ? $t("mall.我") : $t("mall.客户") }}
                  </div>
                  <div class="content">
                    <div v-if="item.contents" class="text-wrap">
                      <div class="text-arrow"></div>
                      <div class="text">
                        {{ item.contents }}
                      </div>
                    </div>
                    <div class="img-list">
                      <div
                        v-for="(image, imgIndex) in item.imageUrlJson"
                        :key="image"
                        class="img-wrap"
                        v-lazy:background-image="image"
                        @click="preview(item.imageUrlJson, imgIndex)"
                      ></div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <div class="action">
            <textarea
              class="form-control"
              rows="3"
              :placeholder="
                $t(
                  'mall.请填写您需要询价的商品的相关描述，并且可以上传多张图样以便得到准确的回复'
                )
              "
              v-model="contents"
            ></textarea>
            <button type="button" @click="saveMessage()">
              {{ $t("mall.回 复") }}
            </button>
          </div>
          <div class="upload">
            <div class="upload-btn">
              <a href="javascript:;" @click="fileClick()">
                {{ $t("mall.上传图片") }}
              </a>
              <input
                @change="fileChange($event)"
                type="file"
                id="addConsultImg"
                style="display: none"
                accept="image/*"
                multiple
              />
            </div>
            <div class="upload-img-list">
              <div
                v-for="img in uploadList"
                :key="img"
                class="img-wrap"
                v-lazy:background-image="img"
              >
                <a class="del" href="javascript:;" @click="imgDel(index)">
                  <i class="ifont ico-del tx-12"></i>
                </a>
              </div>
              <div v-if="!uploadList.length" class="tx-gray9">
                {{
                  $t(
                    "mall.点击选择本地图片，可拖拽图片到弹层或截图后Ctrl + V 粘贴图片"
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setInterval, clearInterval } from "timers";
export default {
  props: ["open", "dId"],
  data() {
    return {
      loading: false,
      loadingCount: 0,
      uploadList: [],
      contents: "",
      page: 1,
      rowsPerPage: 10,
      totalCount: 0,
      totalPage: 1,
      items: [],
      num: 0,
      time: null,
    };
  },
  watch: {
    open() {
      //reset
      this.loading = false;
      this.uploadList = [];
      this.contents = "";
      this.page = 1;
      this.totalPage = 1;
      this.totalCount = 0;
      this.items = [];
      this.num = 0;

      this.getMessage();
      document.body.removeEventListener("paste", this.pasteImg, false); //先解绑
      document.body.addEventListener("paste", this.pasteImg, false);
      clearInterval(this.time);
    },
  },
  mounted() {
    //模态框关闭解绑
    $("#modalMessage")
      .off("hide.bs.modal")
      .on("hide.bs.modal", () => {
        document.body.removeEventListener("paste", this.pasteImg, false);
        clearInterval(this.time);
      });
    $("#modalMessage .msg-list").scroll(() => {
      if ($(".msg-list").scrollTop() < 50) {
        if (this.page < this.totalPage) {
          this.page++;
          this.getMessage("add");
        }
      }
    });
  },
  methods: {
    msgNum() {
      $.api_call(
        "api.Consult.getBySupplier",
        {
          distributorId: this.dId,
          page: 1,
          rowsPerPage: 1,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            this.num = r.Data.Pagination.totalCount;
            let isBottom =
              $(".msg-list").scrollTop() >=
              $(".msg-list ul").height() - $(".msg-list").height();
            if (isBottom && Number(this.num) != Number(this.totalCount)) {
              this.getMessage();
            }
          }
        }
      );
    },
    preview(item, index) {
      this.$parent.loading = true;
      let imgArr = [];
      item.forEach((e) => {
        imgArr.push({
          img: e,
          text: e,
        });
      });
      this.$store.commit("setImgItem", imgArr);
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        viewer.view(index);
        this.$parent.loading = false;
      }, 500);
    },
    getMessage(type) {
      this.loading = true;
      if (!type) {
        this.page = 1;
      }
      $.api_call(
        "api.Consult.getBySupplier",
        {
          distributorId: this.dId,
          page: this.page,
          rowsPerPage: this.rowsPerPage,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.totalPage = r.Data.Pagination.totalPage;
            if (type == "add") {
              //只是添加数据
              r.Data.Results.forEach((e) => {
                this.items.unshift(e);
              });
              return;
            }
            this.items = [];
            r.Data.Results.forEach((e) => {
              this.items.unshift(e);
            });
            this.totalCount = r.Data.Pagination.totalCount;
            //列表未读消息 设为0
            this.$parent.items.forEach((e) => {
              if (e.distributorId == this.dId) {
                this.$set(e, "unReadCnt", 0);
              }
            });
            setTimeout(() => {
              let scrollHeight = $(".msg-list").prop("scrollHeight");
              $(".msg-list").scrollTop(scrollHeight, 200);
            }, 200);
            //循环取数量
            clearInterval(this.time);
            this.time = setInterval(() => {
              this.msgNum();
            }, 5000);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    saveMessage() {
      if (!this.isSysRights("Consult.replyBySupplier")) return;
      if (!this.uploadList.length && !this.contents) {
        ShowTip(this.$t("mall.请输入留言内容"), "danger");
        return;
      }
      this.loading = true;
      $.api_call(
        "api.Consult.replyBySupplier",
        {
          distributorId: this.dId,
          contents: this.contents,
          imageUrlJson: this.uploadList,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.page = 1;
            this.contents = "";
            this.uploadList = [];
            this.getMessage();
            this.$parent.getItems();
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    pasteImg(e) {
      if (this.loading) {
        return false;
      }
      if (this.uploadList.length > 8) {
        ShowTip(this.$t("mall.最多上传9张图片"), "danger");
        return;
      }
      let clipboardData = e.clipboardData,
        i = 0,
        items,
        item,
        types;
      if (clipboardData) {
        items = clipboardData.items;
        if (!items) {
          return;
        }
        item = items[0];
        // 保存在剪贴板中的数据类型
        types = clipboardData.types || [];
        for (; i < types.length; i++) {
          if (types[i] === "Files") {
            item = items[i];
            break;
          }
        }
        // 判断是否为图片数据
        if (item && item.kind === "file" && item.type.match(/^image\//i)) {
          this.imgReader(item);
        }
      }
    },
    imgReader(item) {
      var blob = item.getAsFile(),
        reader = new FileReader();
      // 读取文件后将其显示在网页中
      reader.onload = (e) => {
        this.uploadCostReduceBase64(e.target.result);
      };
      // 读取文件
      reader.readAsDataURL(blob);
    },
    imgDel(index) {
      //删除已上传图片
      this.uploadList.splice(index, 1);
    },
    uploadCostReduceBase64(file, name) {
      if (!this.isSysRights("Consult.uploadImage")) return;
      //上传base64
      this.loading = true;
      this.loadingCount++;
      let image = new Image();
      image.src = file;
      image.onload = () => {
        let width = image.width;
        let height = image.height;
        if (width < 100 || height < 100) {
          this.loading = false;
          ShowTip(this.$t("mall.图片的宽或者高都不能小于100px"), "danger");
          return;
        }
        $.api_call(
          "api.Consult.uploadImage",
          {
            distributorId: this.dId,
            imageBase64: file.split("base64,").pop().replace(/\r\n/g, ""),
            imageBase64Suffix: name ? name.split(".").pop() : "jpg",
          },
          (r) => {
            this.loadingCount--;
            if (!this.loadingCount) {
              this.loading = false;
            }
            if (r.ErrorCode == "9999") {
              this.uploadList.push(r.Data.Results);
            } else {
              if (r.ErrorCode == "1002") {
                userFailure(this);
              } else {
                ShowTip(r.Message, "danger");
              }
            }
          }
        );
      };
    },
    fileAdd(file) {
      //处理文件
      if (this.uploadList && this.uploadList.length > 8) {
        ShowTip(this.$t("mall.最多上传9张图片"), "danger");
        return;
      }
      if (file.type.indexOf("image") >= 0) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.uploadCostReduceBase64(e.target.result, file.name);
        };
      }
    },
    fileList(fileList) {
      //文件上传控件处理
      let files = fileList.files;
      if (files.length + this.uploadList.length > 9) {
        ShowTip(this.$t("mall.最多上传9张图片"), "danger");
        return;
      }
      for (let i = 0; i < files.length; i++) {
        //判断是否为文件夹
        if (files[i].type != "") {
          this.fileAdd(files[i]);
        }
      }
    },
    fileChange(el) {
      if (!el.target.files[0].size) return;
      this.fileList(el.target);
      el.target.value = "";
    },
    fileClick() {
      //触发上传
      document.getElementById("addConsultImg").click();
    },
    dragenter(el) {
      el.stopPropagation();
      el.preventDefault();
    },
    dragover(el) {
      el.stopPropagation();
      el.preventDefault();
    },
    drop(el) {
      el.stopPropagation();
      el.preventDefault();
      this.fileList(el.dataTransfer);
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  .new-msg {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #0866c6;
    color: #fff;
    padding: 0 5px;
    border-radius: 3px;
  }
}
.modal-header {
  display: block;
}
.modal-footer {
  display: block;
}
.msg-list {
  max-height: 350px;
  overflow-y: auto;
  padding-right: 17px;
  ul {
    margin: 0;
    padding: 0;
    li {
      margin-bottom: 20px;
      .date {
        text-align: center;
        margin-bottom: 5px;
      }
      .message-wrap {
        display: flex;
        > .user {
          background-color: #e0e0e0;
          min-width: 40px;
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 50%;
          margin-right: 25px;
        }
        > .content {
          .text-wrap {
            position: relative;
            display: block;
            .text-arrow {
              position: absolute;
              width: 0;
              height: 0;
              border-color: transparent;
              border-style: solid;
              top: 20px;
              left: -10px;
              margin-top: -10px;
              border-width: 10px 10px 10px 0;
              border-right-color: #e0e0e0;
            }
            .text {
              max-width: 600px;
              word-break: break-all;
              margin-bottom: 5px;
              border-radius: 8px;
              background-color: #e0e0e0;
              padding: 10px 15px;
            }
          }
          .img-list {
            display: flex;
            .img-wrap {
              margin-right: 5px;
              width: 40px;
              height: 40px;
              background-size: cover;
              background-position: center;
              border: 1px #ddd solid;
            }
          }
        }
      }
    }
    li.my {
      .message-wrap {
        flex-direction: row-reverse;
        > .user {
          margin-right: 0;
          margin-left: 25px;
          background-color: #17a2b8;
          color: #fff;
        }
        > .content {
          .text-wrap {
            .text-arrow {
              right: -10px;
              left: auto;
              border-width: 10px 0 10px 10px;
              border-left-color: #17a2b8;
            }
            .text {
              background-color: #17a2b8;
              color: #fff;
            }
          }
          .img-list {
            .img-wrap {
              border-color: #17a2b8;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.action {
  display: flex;
  margin-bottom: 10px;
  > textarea {
    margin-right: 15px;
  }
  > button {
    border: 1px solid #0866c6;
    border-radius: 4px;
    background-color: #0866c6;
    color: #fff;
    min-width: 90px;
    height: 60px;
    font-size: 16px;
  }
}
.upload {
  display: flex;
  .upload-btn {
    margin-right: 15px;
    > a {
      position: relative;
      top: 5px;
      background-color: #0866c6;
      color: #fff;
      padding: 5px 15px;
      border-radius: 3px;
    }
  }
  .upload-img-list {
    display: flex;
    .img-wrap {
      position: relative;
      margin-right: 10px;
      width: 60px;
      height: 60px;
      border: 1px #ddd solid;
      background-size: cover;
      background-position: center;
      .del {
        display: none;
        position: absolute;
        right: 0;
        background-color: #0866c6;
        color: #fff;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
      }
    }
    .img-wrap:hover {
      border-color: #17a2b8;
      .del {
        display: block;
      }
    }
  }
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 800px;
    width: 800px;
  }
}
</style>